import { IMPERIAL_TO_METRIC_MAPPING, SYMBOL_TO_UNIT_MAPPING } from 'src/modules/common/constants';
import { SensorProduct } from 'src/sensors/list/SensorsPageMapping';
import { parseStringToUnit } from 'src/utils/parseStringToUnit';
import { Unit } from 'uom';

export const convertFS = (
    flow: SensorProduct['m_flow'],
    isImperial: boolean,
): SensorProduct['m_flow'] => {
    if (!flow) {
        return flow;
    }

    const valueComposed = typeof flow === 'string'
        ? flow
        : flow?.localized.join(', ');

    const [parsedUnit] = parseStringToUnit(valueComposed);

    if (!parsedUnit) {
        return flow;
    }

    const measureSystem = isImperial ? 'imperial' : 'metric';
    const targetUnit = IMPERIAL_TO_METRIC_MAPPING[parsedUnit.unit.name][measureSystem];

    if (!targetUnit || parsedUnit.unit.name === targetUnit.name) {
        return flow;
    }

    const targetUnitSymbol = Object.keys(SYMBOL_TO_UNIT_MAPPING)
        .find((symbol) => SYMBOL_TO_UNIT_MAPPING[symbol].name === targetUnit.name);

    if (!targetUnitSymbol) {
        return flow;
    }

    const convertedValue = Unit.convert(
        parsedUnit.value,
        parsedUnit.unit,
        targetUnit,
    );
    const roundedValue = Math.round(convertedValue);

    return {
        ...flow,
        localized: [`${roundedValue} ${targetUnitSymbol}`],
    };
};
